import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)

export default {
  loading: function() {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '数据加载中'
    })
  },
  clear: function() {
    Toast.clear()
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js